import { encodeBase64Url } from "./base64url";

export type LinkBinarySource = ArrayBuffer | ArrayBufferView<ArrayBufferLike>;

export function copyToArrayBuffer(value: LinkBinarySource): ArrayBuffer {
  if (value instanceof ArrayBuffer) {
    return value.slice(0);
  }
  return new Uint8Array(value.buffer, value.byteOffset, value.byteLength).slice()
    .buffer;
}

export async function sha256Bytes(value: Blob | LinkBinarySource): Promise<Uint8Array> {
  const input =
    value instanceof Blob ? await value.arrayBuffer() : copyToArrayBuffer(value);
  return new Uint8Array(await crypto.subtle.digest("SHA-256", input));
}

export async function sha256Base64Url(value: Blob | LinkBinarySource): Promise<string> {
  return encodeBase64Url(await sha256Bytes(value));
}

export function equalBytes(left: Uint8Array, right: Uint8Array): boolean {
  if (left.byteLength !== right.byteLength) {
    return false;
  }

  let difference = 0;
  for (let index = 0; index < left.byteLength; index += 1) {
    difference |= (left[index] ?? 0) ^ (right[index] ?? 0);
  }
  return difference === 0;
}
